<template>
  <div>
    <!-- <div class="fixed-header w-full"> -->
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="titleName"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      :hideCategory="false"
      staticMode="true"
    ></TopAppBar>
		<div class="d-flex h-full flex-column">
			<TopAppBarDrawer></TopAppBarDrawer>

      <main  class="main-wrapper flex-grow-1">
          <div class="d-flex align-items-center bg-white header-fixed-title">
              <div class="t-headline13 t-color-headlineBlack pda-14 flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center font-m">
                  {{$t('2038')}}
              </div>
              <!-- <div class="mgr-24 right-button"><button class="mdc-icon-button"><i
                  class="material-icons t-headline6">search</i></button></div> -->
          </div>
          <div class="divider"></div>
          <no-data v-if="isNoData === true"></no-data>
            <!-- subtabs -->
           <div v-if="isNoData === false" class="level-container  position-relative pdt-50">
               <div class="container container--narrow pdt-42">
                <div class="level-info-container b-radius4 pdt-24 pdb-8 pdl-24 pdr-24">
                    <div class="t-subtitle4 font-b l-spacing54 t-line-h-24 t-color-whiteHigh">{{$t('788')}}</div>
                    <div class="t-subtitle3 font-m t-line-h-22 mgt-8 t-uppercase t-color-red">{{$t('790',{str:levelProgressData && levelProgressData.level?levelProgressData.level.id:''})}}</div>
                    <div class="level-percentage-container d-flex justify-content-between">
                        <div class="flex-grow-1 mgr-24" id="percentageDiv">
                            <div class="percentage-bar position-relative  mgt-20 mgb-8">
                                <div class="h-4 bg-iconInactive b-radius4" ></div>
                                <div class="percentage-real h-12" v-if="(levelProgressData && levelProgressData.point>0 && roundOfPercentage<=0) && reachLastLevel==false" style="width:1%" id="progressDiv"></div>
                                <div class="percentage-real h-12" v-if="reachLastLevel==false" :style="progress" id="progressDiv"></div>
                                <div class="percentage-real h-12" v-if="reachLastLevel==true" style="width:100%" id="progressDiv"></div>
                            </div>

                            <!-- <div class="t-caption t-color-red">0/300</div>
                            <div class="t-body4 font-r t-color-red" style="padding-left: calc(100% - 40px);">0/300</div> -->
                            <div v-if="roundOfPercentage>=0 && roundOfPercentage<=11 && reachLastLevel==false" class="t-caption t-color-red" style="padding-left:0">{{levelProgressData?levelProgressData.point:''}}/{{levelProgressData && levelProgressData.level?levelProgressData.level.end:''}}</div>
                            <div id="mydiv" ref="foo" v-else-if="roundOfPercentage>11 && reachLastLevel==false"  class="t-body4 font-r t-color-red d-inline-block" :style="progressPoint" :class="progressPointVal==true?' t-right':''">{{levelProgressData?levelProgressData.point:''}}/{{levelProgressData && levelProgressData.level?levelProgressData.level.end:''}}</div>
                            <!-- <div v-else-if="reachLastLevel==false && roundOfPercentage>92 && roundOfPercentage<=100" class="t-body4 font-r t-color-red t-right" style="padding-left:0">{{levelProgressData?levelProgressData.point:''}}/{{levelProgressData && levelProgressData.level?levelProgressData.level.end:''}}</div> -->
                        </div>
                        <div class="d-flex align-items-baseline justify-content-end pdt-8">
                            <div class="t-headline9 t-color-red font-b t-line-h-24 min-w-42 t-right" v-if="(levelProgressData && levelProgressData.point>0 && roundOfPercentage<=0) && reachLastLevel==false">{{$t('791',{str: 1})}}</div>
                            <div class="t-headline9 t-color-red font-b t-line-h-24 min-w-42 t-right" v-else-if="roundOfPercentage>=100 && reachLastLevel==false">{{$t('791',{str: 100})}}</div>
                            <div class="t-headline9 t-color-red font-b t-line-h-24 min-w-42 t-right" v-else-if="roundOfPercentage<=100 && reachLastLevel==false">{{$t('791',{str: roundOfPercentage})}}</div>
                            <div class="t-headline9 t-color-red font-b t-line-h-24 min-w-42 t-right" v-else-if="reachLastLevel==true">{{$t('791',{str: 100})}}</div>
                            <!-- <div class="t-headline14 t-color-red font-r">%</div> -->
                        </div>
                    </div>
                    <div class="pdt-30 pdb-30 d-flex justify-content-between align-items-center">
                        <div class="t-body3 font-r t-color-whiteMedium l-spacing42">{{$t('792')}}</div>
                        <div class="points d-flex justify-content-between align-items-center">
                            <span class="mgr-8 bg-iconInactive b-radius50 w-24 h-24 t-color-whiteHigh point-mark font-b d-flex justify-content-center align-items-center">P</span>
                            <span class="t-color-whiteHigh font-b t-subtitle1" v-if="reachLastLevel==false && roundOfPercentage<100">{{nextLevelPoint}}</span>
                            <span class="t-color-whiteHigh font-b t-subtitle1" v-else-if="reachLastLevel==false && roundOfPercentage>=100">0</span>
                            <span class="t-color-whiteHigh font-b t-subtitle1 " v-else-if="reachLastLevel==true">0</span>
                            <span class="t-color-whiteHigh font-b t-subtitle1 " v-else>{{nextLevelPoint}}</span>
                        </div>
                    </div>
                </div>
                <div class="level-info-container-tobe-fixed t-color-white bg-white">
                    <div class="divider"></div>
                    <div class="container container--narrow">
                        <div class="pdt-15 pdb-14 d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-baseline">
                                <div class="t-subtitle2 font-b t-color-headlineBlack l-spacing48">{{$t('788')}}</div>
                                <div class="t-subtitle2 font-b t-color-red t-uppercase l-spacing42 pdl-8">{{$t('790',{str:levelProgressData && levelProgressData.level?levelProgressData.level.id:''})}}</div>
                            </div>
                            <div class="d-flex align-items-baseline justify-content-end">
                                <div class="t-headline9 t-color-red font-b t-line-h-24 min-w-42 t-right" v-if="(levelProgressData && levelProgressData.point>0 && roundOfPercentage<=0) && reachLastLevel==false">{{$t('791',{str: 1})}}</div>
                                <div class="t-headline9 t-color-red font-b t-line-h-24 min-w-42 t-right" v-else-if="roundOfPercentage>=100 && reachLastLevel==false">{{$t('791',{str: 100})}}</div>
                                <div class="t-headline9 t-color-red font-b t-line-h-24 min-w-42 t-right" v-else-if="roundOfPercentage<=100 && reachLastLevel==false">{{$t('791',{str: roundOfPercentage})}}</div>
                                <div class="t-headline9 t-color-red font-b t-line-h-24 min-w-42 t-right" v-else-if="reachLastLevel==true">{{$t('791',{str: 100})}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <span class="t-color-whiteHigh">{{pointPercentage}}</span> -->
                <div class="position-relative  levels mgt-30 mgb-50 level-stepper">
                    <div v-for="(list,index) in levelData" :class="list.level%2==0?'level-step even':'level-step odd'"  :key="index">
                      <div :class="levelProgressData.point>0 && list.level<=userCurrentLevel?'completed':list.level<=userCurrentLevel+1 && getPointForNextLevel==100?'completed':''"><span class="t-color-whiteHigh"></span>

                        <div class="stage d-flex align-items-center">
                            <span class="level-mark t-headline7 t-color-whiteHigh d-inline-block w-36 h-36 d-flex align-items-center justify-content-center">{{list.level}}</span>
                            <span class="level-title t-subtitle3 font-m t-color-whiteHigh d-inline-block">{{list.name}}</span>
                        </div>
                        <!-- <span class="t-color-whiteHigh">{{getPointForNextLevel}}</span>
                        <span class="t-color-whiteHigh">{{list.level}}</span>
                        <span class="t-color-whiteHigh">{{userCurrentLevel}}</span> -->
                        <div class="root-container">
                            <div v-if="list.level<userCurrentLevel" class="root root-25 done"></div>
                            <div v-else-if="list.level==userCurrentLevel" class="root root-25" :class="(levelProgressData.point>0 || getPointForNextLevel>0) && getPointForNextLevel<=25?'done active-step':getPointForNextLevel>0?addClass25:''"></div>
                            <div v-else class="root root-25"></div>
                            <div v-if="list.level<userCurrentLevel" class="root root-50 done"></div>
                            <div v-else-if="list.level==userCurrentLevel" class="root root-50" :class="getPointForNextLevel>25 && getPointForNextLevel<=50?'done active-step':addClass50"></div>
                            <div v-else class="root root-50"></div>
                            <div v-if="list.level<userCurrentLevel" class="root root-75 done"></div>
                            <div v-else-if="list.level==userCurrentLevel" class="root root-75" :class="getPointForNextLevel>50 && getPointForNextLevel<=75?'done active-step':addClass75"></div>
                            <div v-else class="root root-75"></div>
                            <div v-if="list.level<userCurrentLevel" class="root root-100 done"></div>
                            <div v-else-if="list.level==userCurrentLevel" class="root root-100" :class="getPointForNextLevel>75 && getPointForNextLevel<=99?'active-step':getPointForNextLevel==100?'done':addClass100"></div>
                            <div v-else class="root root-100" ></div>
                        </div>
                      </div>
                    </div>
                </div>
               </div>
               <div class="planets"></div>
           </div>


      </main>
    </div>
    <!-- <div id="tab1" class="flex-grow-1 scroll-y myLevel pdl-16 pdr-16 pdt-16 pdb-0"> -->
      <!-- <div class="myLevelHeader pda-default mgx-auto">
        <div class="t-color-white l-spacing48 t-subtitle2 mgb-4">{{$t('789')}}</div>
        <div class="t-body2 t-color-levelRed">{{levelProgressData && levelProgressData.level?levelProgressData.level.name:''}}</div>
        <div class="levelProcessor d-flex align-items-center justify-content-between mgb-28">
          <div class="levelBar min-h-3 h-3 b-radius4 position-relative">
            <div class="realPercentage position-absolute" :style="progress"></div>
            <span
              class="t-color-levelRed t-caption t-right d-block pdt-16"
            >{{levelProgressData?levelProgressData.point:''}}/{{levelProgressData && levelProgressData.level?levelProgressData.level.end:''}}</span>
          </div>
          <div
            class="levelPercentage t-color-levelRed t-headline5 min-w-60 pdl-8 font-rn"
          >{{$t('791',{str: roundOfPercentage})}}</div>
        </div>
        <div
          class="process-details process-details d-flex justify-content-between align-items-center"
        >
          <div class="t-color-bodyGrayA t-body3">{{$t('792')}}</div>
          <div class="listPointsWrapper d-flex align-items-center">
            <span
              class="listPointIcon d-flex justify-content-center align-items-center t-color-white bg-textField2 mgr-4 pdt-2 t-body3"
            >P</span>
            <span class="t-subtitle1 font-rn t-color-white">{{nextLevelPoint}}</span>
          </div>
        </div>
      </div> -->
      <!-- <div class="levelList pdt-16 mgx-auto">
        <div class="level-indicator d-flex align-items-center">
            <span class="level-indicator-sl border-red">1</span>
            <span class="t-color-white t-caption pdl-8">Preschool</span>
        </div>

        <div><img src="images/level/dot1red.svg" alt="" class="roadmap"></div>

        <div class="level-indicator d-flex align-items-center flex-row-reverse">
            <span class="level-indicator-sl  border-red">2</span>
            <span class="t-color-white t-caption pdr-8">Kindergarten</span>
        </div>

        <div><img src="images/level/dot2red.svg" alt="" class="roadmap"></div>

        <div class="level-indicator d-flex align-items-center">
            <span class="level-indicator-sl  border-red">3</span>
            <span class="t-color-white t-caption pdl-8">1st grade</span>
        </div>

        <div><img src="images/level/dot3red.svg " alt="" class="roadmap"></div>

        <div class="level-indicator d-flex align-items-center flex-row-reverse">
            <span class="level-indicator-sl  border-red">4</span>
            <span class="t-color-white t-caption pdr-8">2nd grade</span>
        </div>

        <div class="position-relative plane-row"><img src="images/level/zet1.png " alt="" class="zet mgx-auto">
            <span class="t-color-white t-caption position-absolute">273 / 300</span>
        </div>

        <div class="level-indicator d-flex align-items-center">
            <span class="level-indicator-sl t-color-white border-white">5</span>
            <span class="t-color-white t-caption pdl-8">3rd grade</span>
        </div>

        <div><img src="images/level/dot2white.svg" alt="" class="roadmap-white"></div>

        <div class="level-indicator d-flex align-items-center flex-row-reverse">
            <span class="level-indicator-sl t-color-white border-white">6</span>
            <span class="t-color-white t-caption pdr-8">4th grade</span>
        </div>

        <div><img src="images/level/dot3white.svg" alt="" class="roadmap-white">
        </div>

        <div class="level-indicator d-flex align-items-center">
            <span class="level-indicator-sl t-color-white border-white">7</span>
            <span class="t-color-white t-caption pdl-8">5th grade</span>
        </div>

        <div><img src="images/level/dot2white.svg" alt="" class="roadmap-white"></div>

        <div class="level-indicator d-flex align-items-center flex-row-reverse">
            <span class="level-indicator-sl  t-color-white border-white">8</span>
            <span class="t-color-white t-caption pdr-8">6th grade</span>
        </div>

        <div><img src="images/level/dot3white.svg" alt="" class="roadmap-white"></div>

        <div class="level-indicator d-flex align-items-center">
            <span class="level-indicator-sl t-color-white border-white">9</span>
            <span class="t-color-white t-caption pdl-8">5th grade</span>
        </div>

        <div><img src="images/level/dot4white.svg" alt="" class="roadmap-last"></div>

      </div> -->
    <!-- </div> -->
  </div>
</template>
<script>
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import levelApi from "@/api/levelApi.js";
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
import NoData from '../common/NoDataLevel.vue'

export default {
  name: "Level",
  data() {
    return {
      titleName: localStorage.getItem('brandName'),
      leftBtnMethod: () => {
        this.$router.go(-1);
      },
      levelProgressData: null,
      levelData: null,
      nextLevelPoint: null,
      pointPercentage: null,
      roundOfPercentage: 0,
      progress: { width: "0%" },
      progressPoint: { 'margin-left':"calc("+this.roundOfPercentage+"% - 20px)" },
      preschoolName: null,
      gradeFirst: null,
      reachLastLevel : false,
      levelMarked: 0,
      flag: 0,
      userCurrentLevel: 0,
      getPointForNextLevel: 0,
      maxPoint: 0,
      addClass25: '',
      addClass50: '',
      addClass75: '',
      addClass100: '',
      progressPointVal: false,
      isNoData: false
    };
  },
  components: {
    TopAppBar,
    TopAppBarDrawer,
    NoData
  },

  mixins: [topAppBarMixin],

  watch: {
    $route(to, from) {},
  },

  mounted() {
    this.setTopAppBarBackSearch(this.$t("788"));
     var visibleStickyHeader = function(){
        var stickyHeader = document.querySelector('.level-info-container-tobe-fixed');
        // var stickyHeaderPosition = stickyHeader.offsetTop;

        var revealHeader = function(){
            var scrolled = window.scrollY;
            // console.log(scrolled)
            document.querySelector('.planets').style.top = (220+(scrolled*0.90))+'px'

            if(scrolled >= 200){
            stickyHeader.classList.add('is-visible')
            } else{
                stickyHeader.classList.remove('is-visible')
            }
        }
        var TopScrollTo = function(){
            if(scrolled!=0){
                setTimeout(function(){
                    // window.scrollTo(0,0)
                    TopScrollTo()
                }, 500)
            }
          }
        window.addEventListener('scroll', revealHeader)
      }
    visibleStickyHeader()
    this.fetchData();
  },
  methods: {
    fetchData() {
      levelApi
        .levelDetail()
        .then((response) => {
          this.levelProgressData = response.data.data;
          if (response.data.data) {
              setTimeout(() => {
                this.isNoData = false
              }, 2000);
          } else {
              this.isNoData = true
          }
          this.nextLevelPoint =
            parseInt(this.levelProgressData.level.end) -
            parseInt(this.levelProgressData.point);
          this.pointPercentage =
            parseInt(this.levelProgressData.point * 100) /
            parseInt(this.levelProgressData.level.end);
          this.roundOfPercentage = this.pointPercentage.toFixed();
          if(this.roundOfPercentage>=100) {
            this.progress = { width: 100 + "%" };
          } else {
            this.progress = { width: this.roundOfPercentage + "%" };
          }
          //this.progress = { width: this.roundOfPercentage + "%" };
          //this.progressPoint = { 'margin-left':"calc("+this.roundOfPercentage+"% - 20px)" };
          this.userCurrentLevel = this.levelProgressData.level.id

          let getPoint = parseInt( this.levelProgressData.point);
          let getEndPoint =  parseInt(this.levelProgressData.level.end);
          let getStartPoint =  parseInt(this.levelProgressData.level.start);

          let subtractPoint = getEndPoint-getStartPoint;

          let getLeftPoint = getPoint-getStartPoint;
          let reachPoint =  (getLeftPoint/subtractPoint)*100;

          //this.getPointForNextLevel =  51
          this.getPointForNextLevel =  Math.round(reachPoint)
          if(this.getPointForNextLevel<=25) {
            this.addClass25='done'
          } else if (this.getPointForNextLevel>25 && this.getPointForNextLevel<=50) {
            this.addClass25='done'
            this.addClass50='done'
          } else if(this.getPointForNextLevel>50 && this.getPointForNextLevel<=75) {
            this.addClass25='done'
            this.addClass50='done'
            this.addClass75='done'
          } else if(this.getPointForNextLevel>75 && this.getPointForNextLevel<=99) {
            this.addClass25='done'
            this.addClass50='done'
            this.addClass75='done'
            this.addClass100='done'
          }else if(this.getPointForNextLevel==100) {
            this.addClass25='done'
            this.addClass50='done'
            this.addClass75='done'
            this.addClass100='done'
          }

          levelApi.levelList().then((response) => {
              this.levelData = response.data.data;
              this.count = this.levelData.length;
              //console.log("responseLevel", this.levelData[this.count-1]);
              this.flag = parseInt(this.count);
              if (this.flag>0) {
                this.isNoData = false
					    } else {
						    this.isNoData = true
					    }
              let lastArrayData = this.levelData[this.count-1]
              this.maxPoint = lastArrayData.start
              // console.log('lastArrayData',lastArrayData.level)
              // console.log('levelProgressData',this.levelProgressData.level.id)
              if(lastArrayData.level==this.levelProgressData.level.id) {
                this.reachLastLevel=true
              } else {
                this.reachLastLevel=false
              }
              let percentage =Math.round( parseInt(this.levelProgressData.point * 100) /
                parseInt(this.maxPoint));
                if(percentage>0 && percentage <=100) {
                  this.levelMarked = 1;
                } else if(percentage>100) {
                  this.levelMarked = 100;
                } else {
                  this.levelMarked = percentage.toFixed();
                }
              //console.log('percentage',levelMarked)

              let percentageDivGrey = document.getElementById("percentageDiv").offsetWidth;
              let progressDivRed = document.getElementById("progressDiv").offsetWidth;
              let contentDivWith = document.getElementById("mydiv").offsetWidth;
              let calculateDivWith = contentDivWith/2;

               let myDivVal = parseInt(progressDivRed)+parseInt(calculateDivWith)
              //  let myDivValllll = parseInt(percentageDivGrey)-parseInt(progressDivRed)
              //  console.log('contentDivWith',contentDivWith)
              //  console.log('refs=>',this.$refs.foo.width)

              //  console.log('progressDivRed',progressDivRed)
              //  console.log('calculateDivWith',calculateDivWith)
              //  console.log('percentageDivGrey',percentageDivGrey)
              //  console.log('myDivVal',myDivVal)
               if(myDivVal>percentageDivGrey) {
                 this.progressPointVal = true
                 this.progressPoint = JSON.parse(JSON.stringify(`margin-left:calc(${100}% - ${contentDivWith+2}px)`))
               } else {
                 this.progressPointVal = false
                 if(calculateDivWith>progressDivRed) {
                   this.progressPoint = JSON.parse(JSON.stringify(`margin-left:0px)`));
                 } else {
                   this.progressPoint = JSON.parse(JSON.stringify(`margin-left:calc(${this.roundOfPercentage}% - ${calculateDivWith}px)`));
                 }

               }

          },1000).catch((err) => {});
        })
        .catch((err) => {});
    },

  },
};
</script>
<style scoped>
.mdc-elevation--z3 {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 var(--Shadow1);
  background-color: var(--DocumentWhite);
}
.myLevel {
  background: url("/images/level/bg-reward.png");
  background-size: cover;
  background-repeat: no-repeat;
}
.myLevelHeader {
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 var(--Shadow1);
  border: solid 0.3px var(--DocumentWhite);
  background-color: var(--WhiteBorder);
  max-width: calc(360px - 32px);
}
.levelList {
  max-width: calc(360px - 32px);
}
.t-color-levelRed {
  color: var(--Textfeilderror);
}
.levelBar {
  width: -webkit-fill-available;
  background-color: var(--bodyGrayA);
}
.realPercentage {
  object-fit: contain;
  border-radius: 7px;
  background-color: var(--Textfeilderror);
  height: 13px;
  left: 0;
  top: -5px;
}
html[dir="rtl"] .realPercentage {
  right: 0;
}
.wp-211 {
  width: 211px;
}
.bg-textField2 {
  background-color: var(--Iconinactive);
}
.listPointIcon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-weight: 500;
}
span.level-indicator-sl {
  display: flex;
  width: 32px;
  height: 32px;

  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 20px;
  font-weight: 600;
}
span.level-indicator-sl.border-red {
  border: 4px solid var(--Textfeilderror);
  background: var(--DocumentWhite);
}
span.level-indicator-sl.border-white {
  border: 2px solid var(--DocumentWhite);
}
.w-auto {
  width: auto;
}
.roadmap {
  max-width: 276px;
  margin: 0 auto;
  height: 30px;
}
.zet {
  max-width: 282px;
  height: 32px;
}

.roadmap-white {
  max-width: 272px;
  margin: 0 auto;
  height: 26px;
}
.roadmap-last {
  max-width: 274px;
  height: 106px;
  margin: 0 auto;
}
.zet-container:before {
  width: 50%;
  height: 12px;
  position: absolute;
  content: "";
  left: 16px;
  top: 16px;
  background: url("/images/level/dot1white.svg");
}
html[dir="rtl"] .zet-container:before {
  right: 16px;
}
.plane-row span {
  left: 50%;
  top: 34px;
  transform: translateX(-60%);
}
html[dir="rtl"] .plane-row span {
  right: 50%;
}
.zet-container:after {
  width: 50%;
  height: 23px;
  position: absolute;
  content: "";
  right: -16px;
  background: url("/images/level/dot4red.svg");
  background-repeat: no-repeat;
}
html[dir="rtl"] .zet-container:after {
  left: -16px;
}
</style>
